import { LoadingOutlined } from '@ant-design/icons'
import {
  PointCloudContextProvider,
  usePointCloudContext,
} from 'features/pointClouds'
import { AlertsSection } from 'pages/pointClouds/components/alerts/AlertSection'
import { Hud } from 'pages/pointClouds/components/hud/Hud'
import { SIDEBAR_WIDTH } from 'pages/pointClouds/PointCloudSidebar'
import { PointCloudWrapper } from 'pages/pointClouds/PointCloudWrapper'
import React, { FC } from 'react'
import styled from 'styled-components'

const MainContentContainer = styled.div<{ $sidebarCollapsed: boolean }>`
  position: absolute;
  top: 0;
  left: ${({ $sidebarCollapsed }) => ($sidebarCollapsed ? 0 : SIDEBAR_WIDTH)}px;
  right: 0;
  bottom: 0;
  transition: left 0.3s ease;
`

interface PointCloudViewProps {
  orgId: string | undefined
  siteId: string
  pointCloudIds?: string[]
  pointCloudOrSceneId: string | undefined
}

type PointCloudViewContentProps = {
  orgId: string | undefined
  siteId: string
  pointCloudOrSceneId: string | undefined
}

const PointCloudViewContent: FC<PointCloudViewContentProps> = ({
  orgId,
  siteId,
  pointCloudOrSceneId,
}) => {
  const { isLoadingPotreePointClouds, isSidebarCollapsed } =
    usePointCloudContext()

  if (isLoadingPotreePointClouds) {
    return <LoadingOutlined />
  }

  return (
    <>
      <MainContentContainer $sidebarCollapsed={isSidebarCollapsed}>
        <PointCloudWrapper />
        <Hud
          orgId={orgId}
          siteId={siteId}
          pointCloudOrSceneId={pointCloudOrSceneId}
        />
      </MainContentContainer>
      <AlertsSection />
    </>
  )
}

export const PointCloudView: React.FC<PointCloudViewProps> = ({
  orgId,
  siteId,
  pointCloudIds,
  pointCloudOrSceneId,
}) => {
  return (
    <PointCloudContextProvider siteId={siteId} pointCloudIDs={pointCloudIds}>
      <PointCloudViewContent
        orgId={orgId}
        siteId={siteId}
        pointCloudOrSceneId={pointCloudOrSceneId}
      />
    </PointCloudContextProvider>
  )
}
